export default {
  headerContainer:
    'shadow-lg! h-full p-2 h-fit! sm:h-fit! sm:p-4 z-10 md:h-fit!',
};
